export default {
    "bulk_assg_altype_title": "Asignación masiva de tipos de alerta",
    "bulk_assg_altype_warning_message": "No hay datos que agregar",
    "bulk_assg_altype_error_message": "No se han editado los modelos de dispositivos",
    "bulk_assg_altype_success_message": "Se han editado los modelos de dispositivos",
    "bulk_assg_altype_from_device_model": "Desde el modelo de dispositivo",
    "bulk_assg_altype_add": "Agregar",
}